import { app } from '../../../app';
import { Controller } from './emails.controller';

app.component('userEmails', {
    bindings: {
        account: '<',
        emails: '<',
    },
    controller: Controller,
    templateUrl: require('./emails.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/emails/emails.component.js